import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueGtag from 'vue-gtag-next'
import Paginate from 'vuejs-paginate-next'

const app = createApp(App)

app.config.globalProperties.axios = axios

app.use(router)
app.use(VueGtag, {
  property: {
    id: 'G-YKG3GV6WLR'
  }
})

app.component('paginate', Paginate)

app.mount('#app')
